import SkeletonBlock from './SkeletonBlock';
import SkeletonTimeWheelPicker from './SkeletonTimeWheelPicker';

interface SkeletonTimingFieldProps {
  showClearButton?: boolean;
}

const SkeletonTimingField = ({
  showClearButton = false
}: SkeletonTimingFieldProps) => (
  <div className='grid grid-cols-1 sm:grid-cols-8 py-2 ~gap-x-6/8 ~gap-y-2/4 items-center'>
    <div className='col-span-6 md:col-span-5 flex items-center ~gap-2/3'>
      <SkeletonBlock className='~w-5/6 ~h-5/6 rounded-full flex-shrink-0' />
      <SkeletonBlock className='~h-4/5 ~w-48/72 border-0' />
    </div>
    <div
      className={`${showClearButton ? 'col-span-3' : ''} flex items-center ~gap-2/3 flex-wrap`}>
      <SkeletonTimeWheelPicker />
      {showClearButton ? (
        <SkeletonBlock className='~h-7/8 ~w-14/16' />
      ) : null}
    </div>
  </div>
);

export default SkeletonTimingField;
